import axios from "axios";
import { GET_HEADER_NOTIFICATION } from "../actions";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const PROXY = process.env.REACT_APP_URL + "api/";

// Load notification
export const getHeaderNotification = (page, limit, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${PROXY}notification/all?page=${page}&limit=${limit}&search=${search}`
    );
    dispatch({
      type: GET_HEADER_NOTIFICATION,
      payload: res.data.result,
    });
  } catch (err) {
    console.error(err);
  }
};
